import { generateCode } from '@apex-org/code-generator';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - v7 is not defined in the uuid package
import { v7 as uuid } from 'uuid';

import { Order } from '../interfaces/IOrder';
import { AccessCode } from '../interfaces/ISettings';
import { getCodeType } from '../utils/get-codetype';

import { CreateDispense } from './dispense.models';

export class CreateSchedule {
  public newSchedule: Order;

  constructor(
    preparer: string,
    accessCode: AccessCode,
    enduser?: string,
    enduserName?: string,
    extId?: string,
    frictionless?: string,
    expireLoaded?: boolean,
    deliveryProvider?: string
  ) {
    const allowAlphanumeric = accessCode.allowAlphanumeric;
    const codeType = getCodeType(allowAlphanumeric);
    const accessCodeMax = accessCode.length.maximum;
    const generatedCodeLength = accessCode.generatedCodeLength || accessCodeMax;
    this.newSchedule = {
      id: `schedule-${uuid()}`,
      scheduleName: extId,
      status: 'OPEN',
      preparer,
      enduser,
      createDateTime: new Date().getTime(),
      expireDateTime: new Date().getTime() + 60000,
      extId,
      flowId: 'flow-schedule-default',
      clientCode: extId === '' ? generateCode(codeType, accessCodeMax) : extId,
      loadCode: generateCode(codeType, generatedCodeLength),
      undoCode: generateCode(codeType, generatedCodeLength),
      reclaimCode: generateCode(codeType, generatedCodeLength),
      reclaimedCode: generateCode(codeType, generatedCodeLength),
      verifyCode: generateCode(codeType, generatedCodeLength),
      dispenses: [],
      deliveryProvider,
    };
    this.newSchedule.dispenses.push(
      new CreateDispense(
        this.newSchedule.id,
        allowAlphanumeric,
        generatedCodeLength,
        frictionless,
        expireLoaded
      ).newDispense
    );
  }

  getSchedule() {
    return this.newSchedule;
  }

  getScheduleId() {
    return this.newSchedule.id;
  }
}
